module.exports = __webpack_public_path__ + "static/media/yt-image.5314f57d.jpg";